var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 389,
    viewBox: "0 0 511 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 389,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1643_20069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 511,
    height: 389
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 389,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1643_20069)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1643_20069)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.088,
    cy: 162.258,
    rx: 107.909,
    ry: 71.2581,
    fill: "#EF2864"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.909,
    cy: 258.742,
    rx: 107.909,
    ry: 71.2581,
    fill: "#28EF9B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 293,
    r: 69,
    fill: "#FB21FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 103,
    r: 69,
    fill: "#4E21FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1643_20069",
    x: -179,
    y: -166,
    width: 844,
    height: 728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1643_20069"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesh);
export default __webpack_public_path__ + "static/media/Mesh.023e5f32bd8b5d7a17197229c7db2e51.svg";
export { ForwardRef as ReactComponent };